<template>
    <div class="contract-approval">
        <h3>审批修改</h3>
      <!-- 面包屑导航 -->
      <el-breadcrumb separator="/" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/yj/work' }">合同管理</el-breadcrumb-item>
        <el-breadcrumb-item>审批管理</el-breadcrumb-item>
      </el-breadcrumb>
  
      <div class="approval-container">
        <!-- 标签页 -->
        <el-tabs v-model="activeTab" type="border-card" @tab-click="handleTabClick">
          <el-tab-pane label="待审批" name="pending">
            <pending-approval 
              ref="pendingTab"
              @refresh="handleRefresh"
              @show-detail="showApplyDetail"
            />
          </el-tab-pane>
          
          <el-tab-pane label="已审批" name="approved">
            <approved-list 
              ref="approvedTab"
              @show-detail="showApplyDetail"
            />
          </el-tab-pane>
          
          <el-tab-pane label="已拒绝" name="rejected">
            <rejected-list 
              ref="rejectedTab"
              @show-detail="showApplyDetail"
            />
          </el-tab-pane>
          
        </el-tabs>
      </div>
  
      <!-- 申请详情对话框 -->
      <el-dialog
        :title="`申请详情 - ${detailData.applyId ? '申请ID: ' + detailData.applyId : ''}`"
        :visible.sync="detailDialogVisible"
        width="80%"
        top="5vh"
        :append-to-body="true"
        :close-on-click-modal="false"
        @closed="handleDialogClosed"
        @opened="handleDialogOpened"
      >
        <apply-detail
          v-if="detailDialogVisible && detailData.applyId"
          :key="detailData.applyId"
          :apply-id="detailData.applyId"
          :can-approve="detailData.canApprove"
          @approved="handleApproved"
          @rejected="handleRejected"
        />
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { mapGetters } from 'vuex';
  import ApplyDetail from '../components/ApplyDetail.vue'
import ApprovedList from '../components/ApprovedList.vue'
import PendingApproval from '../components/PendingApproval.vue'
import RejectedList from '../components/RejectedList.vue'
  
  export default {
    name: 'ContractApproval',
    
    components: {
      PendingApproval,
      ApprovedList,
      RejectedList,
      ApplyDetail
    },
    
    data() {
      return {
        activeTab: 'pending',
        detailDialogVisible: false,
        detailData: {
          applyId: null,
          canApprove: false
        }
      };
    },
    
    computed: {
      ...mapGetters(['roleId'])
    },
    
    created() {
      const t = this.$route.query.tab;
      if (t === 'pending' || t === 'approved' || t === 'rejected') {
        this.activeTab = t;
      }
      // 检查权限 - 等待store初始化完成
      this.checkPermission();
    },

    mounted() {
      this.$nextTick(() => {
        this.handleTabClick({ name: this.activeTab });
      });
    },
    
    beforeRouteEnter(to, from, next) {
      // 在路由进入前检查权限 - 等待store初始化
      next(vm => {
        vm.checkPermission();
      });
    },
    
    beforeRouteUpdate(to, from, next) {
      this.checkPermission();
      const t = to.query.tab;
      if (t === 'pending' || t === 'approved' || t === 'rejected') {
        this.activeTab = t;
        this.$nextTick(() => this.handleTabClick({ name: t }));
      }
      next();
    },
    
    methods: {
      // 检查权限
      checkPermission() {
        // 使用setTimeout确保store已完全初始化
        setTimeout(() => {
          const roleId = this.$store.getters.roleId;
          if (roleId !== 1 && roleId !== '1') {
            this.$message.error('没有权限访问审批页面');
            this.$router.push('/yj/work');
          }
        }, 100);
      },
      
      // 标签页切换
      handleTabClick(tab) {
        const tabRefs = {
          pending: this.$refs.pendingTab,
          approved: this.$refs.approvedTab,
          rejected: this.$refs.rejectedTab
        };
        
        if (tabRefs[tab.name] && tabRefs[tab.name].loadData) {
          tabRefs[tab.name].loadData();
        }
      },
      
      // 显示申请详情
      showApplyDetail({ applyId, canApprove = false }) {
        this.detailData = {
          applyId,
          canApprove
        };
        this.detailDialogVisible = true;
      },
      
      // 处理审批通过
      handleApproved() {
        this.detailDialogVisible = false;
        this.handleRefresh();
      },
      
      // 处理审批拒绝
      handleRejected() {
        this.detailDialogVisible = false;
        this.handleRefresh();
      },
      
      // 处理刷新
      handleRefresh() {
        // 刷新当前标签页
        const tabRefs = {
          pending: this.$refs.pendingTab,
          approved: this.$refs.approvedTab,
          rejected: this.$refs.rejectedTab
        };
        
        if (tabRefs[this.activeTab] && tabRefs[this.activeTab].loadData) {
          tabRefs[this.activeTab].loadData();
        }
      },
      
      // 对话框打开
      handleDialogOpened() {
        // 对话框打开后，确保数据加载
        this.$nextTick(() => {
          if (this.$refs.applyDetail) {
            // 如果组件有loadApplyDetail方法，可以手动触发
          }
        });
      },
      
      // 对话框关闭
      handleDialogClosed() {
        this.detailData = {
          applyId: null,
          canApprove: false
        };
      }
    }
  };
  </script>
  
  <style scoped>
  .contract-approval {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: calc(100vh - 60px);
  }
  
  .breadcrumb {
    margin-bottom: 20px;
  }
  
  .approval-container {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    overflow: hidden;
  }
  
  ::v-deep .el-tabs__content {
    padding: 20px;
    min-height: 500px;
  }
  
  /* 响应式适配 */
  @media screen and (max-width: 768px) {
    .contract-approval {
      padding: 10px;
    }
    
    .breadcrumb {
      font-size: 12px;
    }
    
    ::v-deep .el-tabs__content {
      padding: 10px;
    }
  }
  </style>